export default "__VITE_PUBLIC_ASSET__b2fb161f__"